/* __next_internal_client_entry_do_not_use__ RenderTermsOfServiceRoute auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Route } from "@faire/web-api--source/Route";
import { props as termsOfServiceRouteProps } from "@faire/web-api--source/routes/tos";
import React from "react";
import { TOSType } from "@faire/retailer/views/terms-of-services/data/consts";
import { TermsOfServices } from "@faire/retailer/views/terms-of-services/TermsOfServices";
export var RenderTermsOfServiceRoute = function() {
    return /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, termsOfServiceRouteProps), {
        children: /*#__PURE__*/ _jsx(TermsOfServices, {
            type: TOSType.MAIN
        })
    }));
};
